
const regMap = [{
    reg: '(Network\\s+Error)|(timeout\\s+of\\s+\\d+ms\\s+exceeded)',
    message: 'Service cannot be accessed at this time'
}];

export const mapError = (error) => {
    let message = null;
    
    if (error instanceof Error) {
        message = error.message;
    } else if (typeof(error) === 'string') {
        message = error;
    }

    if (!message) {
        return message;
    }

    for (let idx in regMap) {
        const item = regMap[idx];
        const reg = new RegExp(item.reg, item.flags ?? undefined);
        if (reg.exec(message)) {
            message = item.message;
            break;
        }
    }

    return message;
}

export const handle = (error) => {

}

export const errorInterceptor = (error) => {
    throw new Error(mapError(error));
}